@for (block of safeBlocks(); track $index) {
  @if (wrapTables() && block.type === 'table') {
    <div class="step-evidence-scroll">
      <ng-container [ngTemplateOutlet]="blockTpl" [ngTemplateOutletContext]="{ $implicit: block }" />
    </div>
  } @else {
    <ng-container [ngTemplateOutlet]="blockTpl" [ngTemplateOutletContext]="{ $implicit: block }" />
  }
}

<ng-template #blockTpl let-block>
  @switch (block.type) {
    @case ('paragraph') {
      <p class="blk-p" [innerHTML]="safeHtml(block.html)"></p>
    }
    @case ('subheading') {
      <h4 class="blk-sub">{{ block.text }}</h4>
    }
    @case ('metrics') {
      <div class="blk-metrics">
        @for (metric of block.items; track $index) {
          <div class="blk-metric">
            <div class="blk-metric__label" [innerHTML]="metricLabel(metric)"></div>
            <div class="blk-metric__value">{{ metric.value }}</div>
          </div>
        }
      </div>
    }
    @case ('table') {
      <div class="blk-table-wrap">
        <table class="blk-table">
          <thead>
            <tr>
              @for (header of block.headers; track $index) {
                <th>{{ header }}</th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of block.rows; track $index) {
              <tr>
                @for (cell of row; track $index) {
                  <td [innerHTML]="safeHtml(cell)"></td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
    @case ('graph') {
      <div class="blk-graph-wrap">
        <app-reusable-chart [graph]="block.graph" height="20rem" />
      </div>
    }
    @case ('hypotheses') {
      @for (hyp of block.items; track $index) {
        <div class="blk-hyp blk-hyp--rank{{ hyp.rank }}">
          <h5><span class="blk-tag blk-tag--{{ hyp.tag }}">{{ hyp.tag }}</span>{{ hyp.title }}</h5>
          <p [innerHTML]="safeHtml(hyp.body)"></p>
        </div>
      }
    }
    @case ('list') {
      @if (block.ordered) {
        <ol class="blk-list">
          @for (li of block.items; track $index) {
            <li [innerHTML]="safeHtml(li)"></li>
          }
        </ol>
      } @else {
        <ul class="blk-list">
          @for (li of block.items; track $index) {
            <li [innerHTML]="safeHtml(li)"></li>
          }
        </ul>
      }
    }
    @case ('source') {
      <div class="blk-source">Source: <code>{{ block.text }}</code></div>
    }
  }
</ng-template>
